// extracted by mini-css-extract-plugin
export default {"cls1":"AddPayeeError-ErrorBar_cls1__TrcE3","cls2":"AddPayeeError-ErrorBar_cls2__I1urJ AddPayeeError-ErrorBar_cls1__TrcE3"};